// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 306 ? "learner-dashboard-main" : chunkId) + "." + {"306":"a0cbe01e628056fb5604","414":"05935ea3461868d3ad58","701":"f8c599bdd1093311788c","710":"b900e59142ac3fd67113","812":"99c7fde032a5ac1e68ec"}[chunkId] + ".js";
};